import { decryptData, encryptData } from "utils/dataCipherHelper";
import { instance as axios, setHeaders } from "../config/axiosInstance";

// Create Support Ticket Handler Api
export const createSupportTicketApi = async (data) => {
  const responseData = await axios.post(
    `support/create-ticket`,
    { reqData: encryptData(data) },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// get reference number handler api
export const getReferenceNumberApi = async (data) => {
  const responseData = await axios.get(
    `survey/master-survey-list?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// Create contact us Api handler
export const createContactApi = async (data) => {
  const responseData = await axios.post(
    "support/create-contactUs",
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};
